import URL_ROUTE from "../constants/index.js";
import request from "../configs/AxiosWrapper.js";

let token = sessionStorage.getItem('token');

const plantaFase = () => {
    const listPlantaFase = async () => {
        if (!token) return;
        return await request(URL_ROUTE.LISTARPLANTAFASE, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    };

    const getOPlantaFaseForGUID_OPE = async ({ GUID_OPE }) => {
        return await request(URL_ROUTE.getOPlantaFaseForGUID_OPE, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ GUID_OPE })
        });
    };

    const updatePlantaFase = async ({ ID, ID_PLANTA, ID_FASE, ORDEN, TIEMPO_MIN_ESTIMADO, ESTADO }) => {
        try {
            return await request(URL_ROUTE.UPDATEPLANTAFASE, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ ID, ID_PLANTA, ID_FASE, ORDEN, TIEMPO_MIN_ESTIMADO, ESTADO })
            });
        } catch (error) {
            console.error(error.message);
            throw error;
        }
    };

    return {
        listPlantaFase,
        updatePlantaFase,
        getOPlantaFaseForGUID_OPE
    };
};

export default plantaFase;
